import { render, staticRenderFns } from "./PageABCBooks.vue?vue&type=template&id=70526f1e&scoped=true&"
import script from "./PageABCBooks.vue?vue&type=script&lang=js&"
export * from "./PageABCBooks.vue?vue&type=script&lang=js&"
import style0 from "./PageABCBooks.vue?vue&type=style&index=0&id=70526f1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70526f1e",
  null
  
)

export default component.exports